<script setup>
/**
 * ReadingEndRating — the reading's one rating, as the last item of the reading
 * in the chat, right above "Talk it through · Share" (2026-10-20, SP-R1).
 * Same crystals, same save path. Landed (3+): one quiet line; the bar's own SHARE
 * is the call to action (no second share button here). Below 3, nothing more.
 */
import { ref } from 'vue'
import RatingCrystals from '@/components/ui/RatingCrystals.vue'

const emit = defineEmits(['rated'])
const landed = ref(false)
function onRated(data) {
  const n = Number((data && data.rating) || 0)
  landed.value = n >= 3
  emit('rated', n)
}
</script>

<template>
  <div class="cer" data-testid="reading-rating">
    <RatingCrystals @rated="onRated" />
    <Transition name="cer-fade">
      <p v-if="landed" class="cer-landed" data-testid="reading-landed">This one landed. Someone else might find something in it too.</p>
    </Transition>
  </div>
</template>

<style scoped>
.cer {
  margin: 10px auto 8px; width: 100%; max-width: 560px; padding: 10px 14px 11px; border-radius: 18px; text-align: center;
  background: radial-gradient(125% 95% at 50% 0%, #1c1035 0%, #120827 54%, #0d0520 100%);
  border: 1px solid rgba(231, 201, 131, .2); box-sizing: border-box;
}
.cer :deep(.rc) { margin: 0; background: transparent; border: 0; padding: 0; }
.cer :deep(.rc-row) { flex-wrap: wrap; justify-content: center; }
.cer :deep(.rc-prompt) { flex-basis: 100%; font: 500 19px/1.3 'Letter Serif', 'Cormorant Garamond', Georgia, serif; color: #f3eaff; }
.cer :deep(.rc-row) { gap: 2px 4px; }
.cer :deep(.rc-ball) { min-width: 44px; min-height: 44px; font-size: 26px; }
.cer :deep(.rc-label) { flex-basis: 100%; min-height: 0; margin: 0; line-height: 1.2; color: #b9a6d6; }
.cer :deep(.rc-confirm) { color: #e7c983; }
.cer.cer-pulse { animation: cer-pulse 1.4s ease 2; }
@keyframes cer-pulse { 50% { box-shadow: 0 0 0 6px rgba(231, 201, 131, .35); } }
@media (prefers-reduced-motion: reduce) { .cer.cer-pulse { animation: none; outline: 2px solid #e7c983; } }
.cer-landed { margin: 2px 0 0; font: italic 500 15px/1.35 'Letter Serif', 'Cormorant Garamond', Georgia, serif; color: #cdbbe6; }
.cer-fade-enter-active { transition: opacity .35s ease; }
.cer-fade-enter-from { opacity: 0; }
</style>
